import { render, staticRenderFns } from "./Sub.vue?vue&type=template&id=753c1aa4&"
import script from "./Sub.vue?vue&type=script&lang=js&"
export * from "./Sub.vue?vue&type=script&lang=js&"
import style0 from "./Sub.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports